import { useState, useContext, useEffect } from "react";
import { verificaDni } from "../../../context/Actions/verificaDni/verificaDni";
import { logoutVerificaDni } from "../../../context/Actions/verificaDni/logoutVerificaDni";
import { PortalContext } from "../../../context/Provider";
import { showModal, hideModal } from "../../../context/Actions/modal/modal";
import {
  setUsuario,
  setListError,
} from "../../../context/Actions/registro/registro";
// import { logoutMultiTab } from "../../../context/Actions/multiTab/logoutMultiTab";
import { regexNumero } from "../../../../global/utils/expresionesRegulares";
import {
  logoutPacienteDefault,
  wsGetCambioClave,
} from "../../../context/Actions/paciente/paciente";
import isDniValido from "../../../../global/utils/checkDniValido";
import InputV1 from "../../Genericos/InputV1/InputV1";
import { showToaster } from "../../../../global/context/action/toaster/toaster";
import { GlobalContext } from "../../../../global/context/Provider";
import { IonSpinner } from "@ionic/react";
import styled from "styled-components";

// Contenedor del paso (responsive)
const PasoContainer = styled.div`
  width: 100%;
`;

// Barra de encabezado del modal
const HeaderBar = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: clamp(12px, 2.5vw, 16px) clamp(16px, 3vw, 24px);
  background-color: var(--color-latex30);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
`;

const Title = styled.h1`
  margin: 0;
  color: var(--color-white);
  font-size: clamp(16px, 2.2vw, 20px);
  line-height: clamp(20px, 2.6vw, 24px);
`;

// Cuerpo del modal
const Body = styled.div`
  width: 100%;
  padding: clamp(16px, 3vw, 24px);
`;

// Contenedor del input
const InputBox = styled.div`
  width: min(304px, 100%);
  height: 45px;
  margin: 24px auto 32px auto;
`;

// Botón primario "Siguiente"
const PrimaryButton = styled.button`
  width: min(304px, 100%);
  height: 45px;
  min-width: 100px;
  border-radius: 8px;
  margin: 0 auto 24px auto;
  display: block;
  background: var(--color-primary);
  color: var(--color-white);
  padding: 0;
  border: none;
  box-shadow: 0px 100px 80px rgba(0, 0, 0, 0.07),
    0px 41.7776px 33.4221px rgba(0, 0, 0, 0.0503198),
    0px 22.3363px 17.869px rgba(0, 0, 0, 0.0417275),
    0px 12.5216px 10.0172px rgba(0, 0, 0, 0.035),
    0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0282725),
    0px 2.76726px 2.21381px rgba(0, 0, 0, 0.0196802);
`;

const CambioPasswordPaso1 = ({
  titulo,
  dissmiss,
  pathModal,
  pasoModal,
  navigateTo,
}) => {
  const {
    registroState,
    registroDispatch,
    verificaDniDispatch,
    modalDispatch,
    verificaDniState,
    pacienteDispatch,
  } = useContext(PortalContext);

  const { authState, toasterDispatch } = useContext(GlobalContext);

  const onlyNumbers = (e) => {
    if (!regexNumero.test(e.key)) {
      e.preventDefault();
    }
    if (e.key === "Enter") {
      if (isDniValido(e)) {
        verificandoDni();
      }
    }
  };
  const [dni, SetDni] = useState("");

  // Valida longitud de DNI (7 a 9 dígitos)
  const isDniLengthValid = (dniStr) => {
    if (!dniStr) return false;
    return dniStr.length >= 7 && dniStr.length <= 9;
  };

  const verificandoDni = () => {
    const domValue = (
      document.getElementsByName("nro_documento")[0]?.value || ""
    ).toString();
    const dniStr = (
      registroState?.registro?.usuario?.nro_documento ||
      dni ||
      domValue ||
      ""
    ).toString();

    // Validación visible si está vacío o con longitud inválida
    if (!isDniLengthValid(dniStr)) {
      showToaster(
        {
          texto: "Ingresá un DNI válido (7 a 9 dígitos).",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
      return;
    }
    SetDni(dniStr);
    // Ejecutar verificación (sin bloquear por comparación con paciente actual)
    verificaDni(dniStr)(verificaDniDispatch);
  };

  const onDniChange = (e) => {
    let errx = Object.assign({}, registroState.registro.listError);
    errx.nro_documento = !isDniValido(e);
    setListError(errx)(registroDispatch);
    let usuario = Object.assign({}, registroState.registro.usuario);
    usuario.nro_documento = e.target.value;
    SetDni(e.target.value);
    setUsuario(usuario)(registroDispatch);

    if (isDniValido(e)) {
      SetDni(e.target.value);
      usuario.nro_documento = e.target.value;
      setUsuario(usuario)(registroDispatch);
    }
  };

  const cleanDni = () => {
    logoutVerificaDni()(verificaDniDispatch);
    setTimeout(() => {
      hideModal()(modalDispatch);
    }, 250);
  };

  const solicitarCodigo = () => {
    const domValue = (
      document.getElementsByName("nro_documento")[0]?.value || ""
    ).toString();
    const dniStr = (
      registroState?.registro?.usuario?.nro_documento ||
      dni ||
      domValue ||
      ""
    ).toString();
    wsGetCambioClave(dniStr, changePaso)(pacienteDispatch);
  };

  const changePaso = (isCorrect, data) => {
    if (isCorrect) {
      if (data !== null && data !== undefined) {
        hideModal()(modalDispatch);
        showToaster(
          {
            texto: "Te enviamos el token a tu correo",
            tipo: "success",
          },
          "centroArriba"
        )(toasterDispatch);
        showModal(
          "Auth/CambioPassword/CambioPasswordPaso2",
          {
            dissmiss: cleanDni,
            pathModal: pathModal,
            pasoModal: pasoModal,
            navigateTo: navigateTo,
          },
          {},
          "centro",
          true
        )(modalDispatch);
      }
    } else {
      if (
        data !== null &&
        data !== undefined &&
        data.status === 400 &&
        data.data !== ""
      ) {
        let texto = data.data;
        showToaster(
          {
            texto: texto,
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
        hideModal()(modalDispatch);
        logoutPacienteDefault()(pacienteDispatch);
      } else if (
        data !== null &&
        data !== undefined &&
        data.status !== 400 &&
        data !== false
      ) {
        showToaster(
          {
            texto:
              "Su código no pudo ser verificado, contáctese con el centro de atención al paciente",
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
        hideModal()(modalDispatch);
        logoutPacienteDefault()(pacienteDispatch);
      }
    }
  };

  // Reacción al resultado de verificaDni (flujo legacy): mostrar modal con opción de solicitar token
  useEffect(() => {
    if (
      verificaDniState?.verificaDni?.data !== null &&
      verificaDniState?.verificaDni?.data !== undefined &&
      verificaDniState?.verificaDni?.error === false
    ) {
      hideModal()(modalDispatch);
      setTimeout(() => {
        showModal(
          "Genericos/Mensaje/Mensaje",
          {
            titulo: "¡Te falta un paso!",
            texto:
              "Para seguir, hacé click en el botón 'Solicitar Token' y te enviaremos por correo electrónico.",
            dissmiss: cleanDni,
          },
          [
            {
              text: "Volver",
              clase: "btn-Mensaje b-latex30 rb16m c-latex30",
              accion: cleanDni,
            },
            {
              text: "Solicitar Token",
              clase: "btn-Mensaje-1 rb16m bgc-latex10 c-white",
              accion: solicitarCodigo,
            },
          ],
          "centro",
          true
        )(modalDispatch);
      }, 250);
    } else if (
      verificaDniState?.verificaDni?.error !== null &&
      verificaDniState?.verificaDni?.error !== undefined &&
      verificaDniState?.verificaDni?.error?.data !== "" &&
      verificaDniState?.verificaDni?.error?.status === 400
    ) {
      showToaster(
        {
          texto: verificaDniState?.verificaDni?.error?.data,
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
      if (verificaDniState?.verificaDni?.error?.data) {
        dissmiss();
      }
    } else if (
      verificaDniState?.verificaDni?.error !== null &&
      verificaDniState?.verificaDni?.error !== undefined &&
      verificaDniState?.verificaDni?.error?.status > 1
    ) {
      hideModal()(modalDispatch);
      setTimeout(() => {
        showModal(
          "Genericos/Mensaje/Mensaje",
          {
            titulo: "Dni Inexistente",
            textoNegrita: "Su DNI no se encuentra registrado!",
            texto:
              "Puede volver al login para Iniciar Sesión o Iniciar la registración de una nueva cuenta para este Dni",
            dissmiss: cleanDni,
            danger: true,
          },
          [
            {
              text: "Volver",
              clase: "btn-Mensaje b-latex30 cursor:pointer rb16m c-latex30",
              accion: cleanDni,
            },
          ],
          "centro"
        )(modalDispatch);
      }, 250);
    }
  }, [verificaDniState]);

  useEffect(() => {
    document.getElementsByName("nro_documento")[0].focus();
  }, []);

  return (
    <PasoContainer>
      <HeaderBar>
        <Title>{titulo === "" ? "Error en el sistema" : titulo}</Title>
        <div className="cruz" onClick={dissmiss}>
          <div className="cruzParte1"></div>
          <div className="cruzParte2"></div>
        </div>
      </HeaderBar>
      <Body>
        <InputBox>
          <InputV1
            name="nro_documento"
            headerStr="Ingresá tu número de documento"
            placeholderText="12345678"
            inputType="number"
            onChange={onDniChange}
            onKeyPress={onlyNumbers}
            className="inputNonScroll rb16m"
            maxLength="9"
            checkError={registroState.registro.listError.nro_documento}
            isRequired={true}
          />
        </InputBox>
        <PrimaryButton
          id="btnSiguienteCambioPassword"
          className="rb18m"
          onClick={verificandoDni}
        >
          {verificaDniState.verificaDni.loading ? (
            <span>
              <IonSpinner name="lines-small" />
            </span>
          ) : (
            "Siguiente"
          )}
        </PrimaryButton>
      </Body>
    </PasoContainer>
  );
};

export default CambioPasswordPaso1;
